import { Box, Typography, Button, Paper } from '@mui/material'
import { useNavigate } from 'react-router-dom'

const NotWhitelistedPage = () => {
  const navigate = useNavigate()

  return (
    <Box
      sx={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
        p: 2,
      }}
    >
      <Paper
        elevation={6}
        sx={{
          maxWidth: 520,
          p: { xs: 3, sm: 4 },
          borderRadius: 2,
          textAlign: 'center',
        }}
      >
        <Typography variant="h5" sx={{ fontWeight: 700, mb: 2, color: '#1a1a1a' }}>
          Access not enabled
        </Typography>
        <Typography variant="body1" sx={{ color: 'text.secondary', mb: 3, lineHeight: 1.7 }}>
          Your account is not on the authorized list for this administration portal. If you
          believe this is an error, please contact your website administrator so they can review
          your access request.
        </Typography>
        <Button variant="contained" color="primary" onClick={() => navigate('/login', { replace: true })}>
          Return to sign in
        </Button>
      </Paper>
    </Box>
  )
}

export default NotWhitelistedPage
